// extracted by mini-css-extract-plugin
export default {"main_section":"mens_main_section__7dV2H","product_section":"mens_product_section__ovqCh"};